import dayjs from 'dayjs'
import uuid from 'react-uuid'
//import { message } from 'antd'

const info = text => {

  // TODO: SCAN
  //message.info(text)
  alert (text)
}

let isIOSDenyCamera = false

export function isIOS() {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

export function isAndroid(){
  let ua = navigator.userAgent.toLowerCase();
  let android = ua.indexOf("android") > -1 && ua.indexOf("mobile") > -1;
  let chrome = window.chrome;
  if(android && chrome) return true;
  return false;
}

export function isMobile(){
  let mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  try{
    if(navigator.userAgent.includes('SamsungBrowser') && DeviceMotionEvent !== undefined)
      return true;
    if(!mobile && navigator.userAgent.includes('Macintosh') && 
       DeviceMotionEvent !== undefined &&
       !navigator.userAgent.includes('Chrome') &&
       !navigator.userAgent.includes('Firefox')) return true;
    return mobile;
  }catch(e){
    return false;
  }
} 

export const deviceId = uuid();
let myScanId = null;
export function getScanId(isNew){
  if(myScanId === null || isNew){
    myScanId = dayjs().format('DD_MM_YYYY_HH_mm_ss');
  }
  return myScanId;
}

export const allowOrDeniedCameraAccess = async func => {
  if (isIOS && isIOSDenyCamera) {
    info('Camera access was denied by user.')
    return
  }
  const stream = await navigator.mediaDevices
    .getUserMedia({ audio: false, video: { width: { min: 640 }, height: { min: 480 } } })
    .catch(err => {
      info('Camera access was denied by user.')
      console.log(err.name + ': ' + err.message)
      if (isIOS) isIOSDenyCamera = true
    })
  if (stream) {
    func()
  }
}
